import React from "react";
import { useState } from "react";
import { LazyLoadImage } from "react-lazy-load-image-component";
import "react-lazy-load-image-component/src/effects/blur.css";

import Nav from "../Reuseable/Nav";
import { NavLink } from "react-router-dom";
import sublinks from "../../assets/Datas/NavData";
import { useGlobalContext } from "../../Context";

export default function BeyondNav() {
  const [open, setOpen] = useState(false);
  const {nav} = useGlobalContext()
  return (
    <header class={ `${nav ? "Navi":""}  w-full p-4 top-0 left-0 z-[1000]`}>
      <nav
        class="mx-auto flex max-w-7xl items-center justify-between p-0.5 px-4 lg:px-8"
        aria-label="Global"
      >
        <div class="flex lg:flex-1">
          <NavLink
            to={"/"}
            className="Nav__Link"
            style={{ color: "#007cba", backgroundColor: "transparent" }}
            // onClick={() => handleActive()}
          >
            <img
              src={require("../../assets/images/BLlogopng.png")}
              alt=""
              className="bl__logo"
            />
          </NavLink>
        </div>
        <div class="flex lg:hidden">
          <button
            type="button"
            class="-m-2.5 inline-flex items-center justify-center rounded-md p-2.5 text-gray-700"
          >
            <span class="sr-only">Open main menu</span>
            <svg
              class="h-[40px] w-[40px] text-[#007cba]"
              fill="text-white"
              viewBox="0 0 24 24"
              stroke-width="1.5"
              stroke="currentColor"
              aria-hidden="true"
              onClick={() => setOpen(!open)}
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                d="M3.75 6.75h16.5M3.75 12h16.5m-16.5 5.25h16.5"
              />
            </svg>
          </button>
        </div>
        <div class="hidden lg:flex lg:gap-x-12">
          {sublinks.map((link, index) => {
            const { page, links } = link;
            return <Nav href={links[0].url} title={page} classes={"text-[#007cba]"}/>;
          })}
        </div>
      </nav>
      {/* Mobile menu, show/hide based on menu open state. */}
      <div class="lg:hidden" role="dialog" aria-modal="true">
        {/* <!-- Background backdrop, show/hide based on slide-over state. --> */}
        <div class={`${open ? "inset-0" : ""} fixed z-10`}></div>
        <div
          class={`${
            open ? "right-0" : "right-[-100%]"
          } fixed inset-y-0 transition-all duration-1000 w-full z-10 sm:w-[80%] overflow-y-auto p-4 bg-[#007cba] px-6 py-6  sm:max-w-[500px] sm:ring-1 sm:ring-gray-900/10`}
        >
          <div class="flex items-center justify-between mb-[30px]">
            <NavLink
              to={"/"}
              className="Nav__Link"
            >
              <img
                src={require("../../assets/images/BLlogopng.png")}
                alt=""
                className="bl__logo bg-white rounded-full"
                onClick={() => setOpen(!open)}
              />
            </NavLink>
            <button
              onClick={() => setOpen(!open)}
              type="button"
              class="-m-2.5 rounded-md p-2.5 text-gray-700"
            >
              <span class="sr-only">Close menu</span>
              <svg
                class="h-[30px] w-[30px] text-white"
                fill="white"
                viewBox="0 0 24 24"
                stroke-width="1.5"
                stroke="currentColor"
                aria-hidden="true"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  d="M6 18L18 6M6 6l12 12"
                />
              </svg>
            </button>
          </div>
          <div class="pt-[20px] flow-root">
            <div class="-my-6 pl-[1rem] flex flex-col gap-[30px] divide-y divide-gray-500/10">
              {sublinks.map((link, index) => {
                const { page, links } = link;
                return (
                  <Nav
                    click={() => setOpen(!open)}
                    href={links[0].url}
                    title={page}
                    classes={"text-white"}
                  />
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </header>
  );
}
